import PageHeading from '../ReusableComponents/PageHeading';
import React, { useEffect, useState } from "react";
import axios from "axios";
import { useDispatch, useSelector } from "react-redux";
import { URL } from "../../variables";
import { logout } from "../../actions/AppActions";
import { Pagination } from '@material-ui/lab';
import ModalQuestao from "../CategoriasQuestoes/ModalQuestao";
import { CircularProgress } from "@material-ui/core";
import Search from '../ReusableComponents/Search';
import { MdFilterList } from "react-icons/md";
import { FaArrowRight } from "react-icons/fa";
import { useHistory } from "react-router-dom";
import "../ReusableComponents/ModulePage.css";
import "./BancaQuestoes.css";

const BancaQuestoes = () => {
  const [questoes, setQuestoes] = useState([]);
  const [loading_questions, setLoadingQuestions] = useState(true);

  const [search, setSearch] = useState('');
  const [disciplines, setDisciplines] = useState([]);
  const [filters, setFilters] = useState({
    tipo_questao: "",
    escolaridade: "",
    nivel_dificuldade: "",
    disciplina: "all",
  });
  const [pagination, setPagination] = useState({ current_page: 1, last_page: 1 });
  const [errorMessage, setErrorMessage] = useState("");
  const dispatch = useDispatch();
  const token = useSelector(store => store.AppReducer.token);
  const history = useHistory();

  const fetchQuestoes = async (page = 1, search_ = search, categoria_id = filters.disciplina) => {
    setLoadingQuestions(true)
    setErrorMessage("");
    try {
      const response = await axios.get(
        `${URL}api/faculdade/get_questoes/${categoria_id}?page=${page}&search=${search_}&public=1&tipo_questao=${filters.tipo_questao}&escolaridade=${filters.escolaridade}&dificuldade=${filters.nivel_dificuldade}`,
        {
          headers: {
            Authorization: `Bearer ${token}`, // Adiciona o token ao cabeçalho
            Accept: `application/json`, // Adiciona o token ao cabeçalho
          },
        }
      );
      setQuestoes(response.data.questoes);
      setDisciplines(response.data.categorias)
      setPagination(response.data.pagination);
      // Extract unique disciplines
    } catch (error) {
      if (error.response && error.response.status === 404) {
        console.error("Erro ao buscar questões: Endpoint não encontrado.");
      }
      if (error.response && error.response.status === 401) {
        localStorage.removeItem('token'); localStorage.removeItem('user');
        dispatch(logout())
      }
      else {
        console.error("Erro ao buscar questões:", error);
        setErrorMessage("Não foi possível carregar as questões. Tente novamente.");
      }
    }
    setLoadingQuestions(false)

  };

  useEffect(() => {
    fetchQuestoes();
  }, []);

  // Função para remover uma questão
 

  const applyFilters = () => {
    fetchQuestoes(1, search, filters.disciplina);

  };

  // Calculate the items to display based on the current page


  // Render options for discipline filter
  const renderDisciplineOptions = () => {
    return disciplines.map((disciplina, index) => (
      <option key={disciplina.id} value={disciplina.id}>
        {disciplina.name}
      </option>
    ));
  };

  // Handle page change

  // Render pagination controls


  return (
    <div className="banca-questoes module-page">
      <section className="card module-card">
        <div className="card-body">
          <PageHeading title="Questões Públicas" description="Encontre questões por disciplina, escolaridade e dificuldade para utilizar nas suas avaliações." icon="questions" />

        {/* Filtro de Questões */}
        <div className="banca-questoes-filters hidethis">
         
          <div className="row justify-content-center">
          <div className="col-lg-6 col-12 mb-3">

          <label className="form-label text-muted">
                Pesquisar
              </label>
          <Search hide_class placeholder="Pesquisar pelo enunciado da questão" ValueChange={value => {

            setSearch(value)

          }} />
          </div>
            <div className="col-12 col-md-6 col-lg-3 mb-3">
              <label htmlFor="tipo_questao" className="form-label text-muted">
                Tipo de Questão
              </label>
              <select
                id="tipo_questao"
                name="tipo_questao"
                className="form-control form-select"
                value={filters.tipo_questao}
                onChange={(e) =>
                  setFilters({ ...filters, tipo_questao: e.target.value })
                }
              >
                <option value="">Todos</option>
                <option value="simples">Objetiva</option>
                <option value="dissertativa">Dissertativa</option>
              </select>
            </div>
            <div className="col-12 col-md-6 col-lg-3 mb-3">
              <label htmlFor="escolaridade" className="form-label text-muted">
                Escolaridade
              </label>
              <select
                id="escolaridade"
                name="escolaridade"
                className="form-control form-select"
                value={filters.escolaridade}
                onChange={(e) =>
                  setFilters({ ...filters, escolaridade: e.target.value })
                }
              >
                <option value="">Todos</option>
                <option value="Ensino Fundamental">Ensino Fundamental</option>
                <option value="Ensino Médio">Ensino Médio</option>
                <option value="Ensino Superior">Ensino Superior</option>
              </select>
            </div>
            <div className="col-12 col-md-6 col-lg-6 mb-3">
              <label
                htmlFor="nivel_dificuldade"
                className="form-label text-muted"
              >
                Nível de Dificuldade
              </label>
              <select
                id="nivel_dificuldade"
                name="nivel_dificuldade"
                className="form-control form-select"
                value={filters.nivel_dificuldade}
                onChange={(e) =>
                  setFilters({
                    ...filters,
                    nivel_dificuldade: e.target.value,
                  })
                }
              >
                <option value="">Todos</option>
                <option value="Fácil">Fácil</option>
                <option value="Médio">Médio</option>
                <option value="Difícil">Difícil</option>
              </select>
            </div>
            <div className="col-12 col-md-6 col-lg-6 mb-3">
              <label htmlFor="disciplina" className="form-label text-muted">
                Disciplina
              </label>
              <select
                id="disciplina"
                name="disciplina"
                className="form-control form-select"
                value={filters.disciplina}
                onChange={(e) =>
                  setFilters({ ...filters, disciplina: e.target.value })
                }
              >
                <option value="all">Todos</option>
                {renderDisciplineOptions()}
              </select>
            </div>
          </div>
          <div className="d-flex justify-content-end">
            <button className="btn btn-primary flex align-center jcc" type="button" disabled={loading_questions} onClick={applyFilters}>
              <MdFilterList size={18} aria-hidden="true" /> Aplicar filtros
            </button>
          </div>
        </div>
        </div>
      </section>

      <div className="banca-questoes-results" aria-live="polite" aria-busy={loading_questions}>
        {loading_questions ? (
          <div className="card module-card"><div className="card-body d-flex justify-content-center"><CircularProgress aria-label="Carregando questões" /></div></div>
        ) : errorMessage ? (
          <div className="card module-card"><div className="card-body"><p className="alert alert-danger mb-0" role="alert">{errorMessage}</p></div></div>
        ) : questoes.length === 0 ? (
          <div className="card module-card"><div className="card-body"><p className="text-muted mb-0">Nenhuma questão encontrada com os filtros aplicados.</p></div></div>
        ) : questoes.map((questao, index) => (
          <article key={questao.id} className="card module-card banca-questao">
            <div className="card-body">
              <header className="banca-questao-heading">
                <h2>Questão {index + 1}</h2>
                <button
                  className="btn btn-warning flex align-center jcc"
                  type="button"
                  onClick={() => history.push('/questoes/register/' + questao.categoria_id + '?questao_id=' + questao.id)}
                >
                  Utilizar questão <FaArrowRight aria-hidden="true" />
                </button>
              </header>
              <div className="banca-questao-content"><ModalQuestao questao={questao} /></div>
            </div>
          </article>
        ))}
      </div>
      {!loading_questions && !errorMessage && pagination.last_page > 1 && (
        <div className="d-flex justify-content-end">
          <Pagination className="hidethis"
            count={pagination.last_page}
            page={pagination.current_page}
            onChange={(_, value) => fetchQuestoes(value, search)}
          />
        </div>
      )}
    </div>
  );
};

export default BancaQuestoes;
